export default __webpack_public_path__ + "static/media/pgc.fd100d86.jpg";